define('DateCalculations.Test', [
  'Backbone',
  'Moment',
  'Utils',
  'DateCalculations'
], function DateCalculationsTest(Backbone, moment, Utils, DateCalculations) {
  'use strict';

  function testWeekForBusinessDays(businessDays, asserts) {
    var format = 'ddd, MMM DD';
    console.log('==== Running tests for: ' + businessDays + ' business days ====');
    console.log('========');

    Object.keys(asserts).forEach(function forEach(weekday) {
      var startMoment = moment(asserts[weekday][0]);
      var expectedMoment = moment(asserts[weekday][1]);
      var calculated = DateCalculations.addBusinessDaysToMoment(startMoment.clone(), businessDays);
      console.log(
        startMoment.format(format),
        '| Passed:',
        calculated.moment.isSame(expectedMoment),
        '| Calculated: ' + calculated.moment.format(format),
        '| Expected: ' + expectedMoment.format(format)
      );
    });
    console.log('========');
  }

  return {
    enabled: false,

    isEnabledWithParam: function isTestParamInUrl() {
      var urlParams = Utils.parseUrlOptions(window.location.search);
      return Boolean(urlParams) && Boolean(urlParams.testbusinessdays);
    },

    runIfEnabled: function runIfEnabled() {
      if (!this.enabled && !this.isEnabledWithParam()) {
        return;
      }
      this.run();
    },

    run: function run() {
      testWeekForBusinessDays(1, {
        monday: ['2022-02-07', '2022-02-08'],
        tuesday: ['2022-02-08', '2022-02-09'],
        wednesday: ['2022-02-09', '2022-02-10'],
        thursday: ['2022-02-10', '2022-02-11'],
        friday: ['2022-02-11', '2022-02-14'],
        saturday: ['2022-02-12', '2022-02-15'],
        sunday: ['2022-02-13', '2022-02-15']
      });
      testWeekForBusinessDays(2, {
        monday: ['2022-02-07', '2022-02-09'],
        tuesday: ['2022-02-08', '2022-02-10'],
        wednesday: ['2022-02-09', '2022-02-11'],
        thursday: ['2022-02-10', '2022-02-14'],
        friday: ['2022-02-11', '2022-02-15'],
        saturday: ['2022-02-12', '2022-02-16'],
        sunday: ['2022-02-13', '2022-02-16']
      });
      testWeekForBusinessDays(3, {
        monday: ['2022-02-07', '2022-02-10'],
        tuesday: ['2022-02-08', '2022-02-11'],
        wednesday: ['2022-02-09', '2022-02-14'],
        thursday: ['2022-02-10', '2022-02-15'],
        friday: ['2022-02-11', '2022-02-16'],
        saturday: ['2022-02-12', '2022-02-17'],
        sunday: ['2022-02-13', '2022-02-17']
      });
      testWeekForBusinessDays(4, {
        monday: ['2022-02-07', '2022-02-11'],
        tuesday: ['2022-02-08', '2022-02-14'],
        wednesday: ['2022-02-09', '2022-02-15'],
        thursday: ['2022-02-10', '2022-02-16'],
        friday: ['2022-02-11', '2022-02-17'],
        saturday: ['2022-02-12', '2022-02-18'],
        sunday: ['2022-02-13', '2022-02-18']
      });
      testWeekForBusinessDays(5, {
        monday: ['2022-02-07', '2022-02-14'],
        tuesday: ['2022-02-08', '2022-02-15'],
        wednesday: ['2022-02-09', '2022-02-16'],
        thursday: ['2022-02-10', '2022-02-17'],
        friday: ['2022-02-11', '2022-02-18'],
        saturday: ['2022-02-12', '2022-02-21'],
        sunday: ['2022-02-13', '2022-02-21']
      });
      testWeekForBusinessDays(6, {
        monday: ['2022-02-07', '2022-02-15'],
        tuesday: ['2022-02-08', '2022-02-16'],
        wednesday: ['2022-02-09', '2022-02-17'],
        thursday: ['2022-02-10', '2022-02-18'],
        friday: ['2022-02-11', '2022-02-21'],
        saturday: ['2022-02-12', '2022-02-22'],
        sunday: ['2022-02-13', '2022-02-22']
      });
      testWeekForBusinessDays(7, {
        monday: ['2022-02-07', '2022-02-16'],
        tuesday: ['2022-02-08', '2022-02-17'],
        wednesday: ['2022-02-09', '2022-02-18'],
        thursday: ['2022-02-10', '2022-02-21'],
        friday: ['2022-02-11', '2022-02-22'],
        saturday: ['2022-02-12', '2022-02-23'],
        sunday: ['2022-02-13', '2022-02-23']
      });
      testWeekForBusinessDays(8, {
        monday: ['2022-02-07', '2022-02-17'],
        tuesday: ['2022-02-08', '2022-02-18'],
        wednesday: ['2022-02-09', '2022-02-21'],
        thursday: ['2022-02-10', '2022-02-22'],
        friday: ['2022-02-11', '2022-02-23'],
        saturday: ['2022-02-12', '2022-02-24'],
        sunday: ['2022-02-13', '2022-02-24']
      });
    }
  };
});
